import React from 'react';

const Card = ({ icon, title, description, isStat = false, value = null, className = '' }) => {
  return (
    <div className={`card ${isStat ? 'stat-card' : ''} ${className}`}>
      <i className={icon}></i>
      {isStat && value && <h3 style={{ fontSize: '2.5rem' }}>{value}</h3>}
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default Card;